/* eslint-disable no-console */
export class Logger {
  private readonly _prefix;

  constructor(prefix = 'Logger') {
    this._prefix = prefix;
  }

  log(message: string, context?: unknown): void {
    const now = this.now;
    console.log(`${now} LOG | [${this._prefix}] `, message);
    if (context) {
      console.log(`${now} LOG | [${this._prefix}] `, context);
    }
  }

  warn(message: string, context?: unknown): void {
    const now = this.now;
    console.warn(`${now} | WARN [${this._prefix}] `, message);
    if (context) {
      console.warn(`${now} | WARN [${this._prefix}] `, context);
    }
  }

  error(message: string, error?: unknown): void {
    const now = this.now;
    console.error(`${now} | ERROR [${this._prefix}] `, message);
    if (error) {
      console.error(`${now} | ERROR [${this._prefix}] `, error);
    }
  }

  get now(): string {
    const current = new Date();
    const date = current.getDate();
    const month = current.getMonth() + 1;
    const year = current.getFullYear();
    const hour = current.getHours();
    const minute = current.getMinutes();
    const second = current.getSeconds();
    const milliseconds = current.getMilliseconds();
    return `${date}/${month}/${year}, ${hour}:${minute}:${second}:${milliseconds}`;
  }
}
